/*---------------------------------------------------------------------------------
 *
 *	This page contains contact info and some references.
 *
 * --------------------------------------------------------------------------------
 */

import React from "react";
import PermanentDrawerLeft from "../components/PermanentDrawerLeft";
import { makeStyles, Typography } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  content: {
    paddingLeft: "280px",
    paddingTop: "100px",
    textAlign: "center",
  },
  img: {
    width: "60%",
  },
}));

function ContactPage() {
  const classes = useStyles();
  return (
    <div>
      <PermanentDrawerLeft></PermanentDrawerLeft>
      <main className={classes.content}>
        <Typography paragraph>
          This project was developed by Neeha Hammad, under the supervision of
          Professor. Peter Zaspel.
          <br />
          <br />
          n.hammad@jacobs-university.de
          <br />
          p.zaspel@jacobs-university.de
          <br />
          <br />
          References:
          <br />
          https://www.brandcrowd.com/maker/logo/green-toy-robot-115307
          <br />
          https://github.com/MenesesGHZ/polynomial-regression-js
        </Typography>
      </main>
    </div>
  );
}

export default ContactPage;